import React, {useState} from 'react';
import {FieldProp} from '../../types';
import {FileUpload} from './FileUpload';
import {fieldValueLabel} from '../../_helpers/form';
import {FormState} from '../Form';
import moment from 'moment';

type FileUploadWithRevisionsProps = FieldProp & {};

/**
 * Wrapper around NestedForm for providing a FileUpload component with Revision history
 * NOTE: This component can ONLY be used as a CustomComponent on top of a NestedForm
 * @param props
 * @constructor
 */

export const FileUploadWithRevisions: React.FunctionComponent<FileUploadWithRevisionsProps> = ({
                                                                                                   field,
                                                                                                   fieldState,
                                                                                                   onChange,
                                                                                                   onBlur,
                                                                                                   value,
                                                                                                   displayOnly,
                                                                                                   setIsBusy,
                                                                                               }): JSX.Element => {
    const fileFieldId = field?.flowCustomDisplayComponentConfig?.fileFieldId;
    const fileField = fileFieldId && field?.nestedForm?.fieldMap?.hasOwnProperty(fileFieldId) ? field.nestedForm.fieldMap[fileFieldId] : null;
    const revisionFieldId = field?.flowCustomDisplayComponentConfig?.revisionFieldId;
    const revisionField = revisionFieldId && field?.nestedForm?.fieldMap?.hasOwnProperty(revisionFieldId) ? field.nestedForm.fieldMap[revisionFieldId] : null;

    if (!(fileField && revisionField)) return (<></>);

    const newValue = value.find((v: any) => !v.hasOwnProperty('id'));
    const fileFieldValue = newValue && newValue.hasOwnProperty('input_' + fileFieldId) ? newValue['input_' + fileFieldId] : '';
    const revisions = value.filter((v: any) => v.hasOwnProperty('id') && v.id);

    return (
        <>
            <FileUpload
                field={fileField}
                fieldState={fieldState}
                value={fileFieldValue}
                onChange={(file: string) => {
                    // remove anything from value where there is no id
                    let newState = value.filter((v: any) => v.hasOwnProperty('id') && v.id);

                    if (file) {
                        // add new value
                        newState = [
                            ...newState,
                            {
                                ['input_' + fileFieldId]: file,
                                ['input_' + revisionFieldId]: value.length
                            }
                        ];
                    }

                    onChange && onChange(newState);
                }}
                onBlur={() => {}}
                displayOnly={displayOnly}
                setIsBusy={setIsBusy}
            />

            {revisions && revisions.length > 0 &&
            <>
                <h5>Revisions</h5>
                <div className="list-group file-upload-revisions">
                    {revisions.sort().map((v: any) => {
                        const fileFieldValue = v.hasOwnProperty('input_' + fileField.id) ? v['input_' + fileField.id] : '';
                        const revisionFieldValue = v.hasOwnProperty('input_' + revisionField.id) ? v['input_' + revisionField.id] : '';
                        return (
                            <div className="list-group-item"
                                 key={v.id}>
                                <div className="d-flex w-100 justify-content-between">
                                    <div>{fieldValueLabel({fieldValues: {[fileField.name]: fileFieldValue}} as FormState, fileField)}</div>
                                    <div>
                                        <small>Rev. {revisionFieldValue}</small>
                                        <small> on {moment(v.date_created).format('M/D/YYYY')}</small>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
            }
        </>
    );

};